import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function MenuCTA() {
  return (
    <section id="menu" className="max-w-7xl mx-auto px-6 py-28 lg:py-36" data-testid="menu-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6 }}
        className="border-2 border-zinc-800 bg-coal-800 px-8 py-16 sm:px-16 text-center"
      >
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-ember mb-4">The Feed</p>
        <h2 className="font-display text-6xl sm:text-7xl leading-none uppercase mb-6 text-gold-shine" data-testid="menu-heading">
          Our Menu
        </h2>
        <p className="text-zinc-400 text-base leading-relaxed max-w-lg mx-auto mb-10">
          23 pizzas, gozleme, pides, kebabs, snack packs, burgers, wings, deals and more — browse the full menu with every price.
        </p>
        <Link
          to="/menu"
          data-testid="view-menu-button"
          className="inline-flex items-center gap-3 bg-ember hover:bg-ember-hover text-white font-bold px-10 py-5 text-base tracking-wide uppercase transition-colors duration-300 ember-glow"
        >
          View Full Menu <ArrowRight className="w-5 h-5" />
        </Link>
        <p className="mt-8 font-mono text-sm tracking-[0.15em] uppercase text-zinc-500" data-testid="menu-order-note">
          Ready to order? Ordering happens on our order page
        </p>
      </motion.div>
    </section>
  );
}
